module.exports = __webpack_public_path__ + "img/2.d85ea9ac.png";